import { Pipe, PipeTransform } from '@angular/core';
import { round } from '../../utils/round';

@Pipe({
  name: 'round',
  standalone: false
})
export class RoundPipe implements PipeTransform {
  public transform(value: string | number | undefined): string {
    if (!value) {
      return '0';
    }
    let result = value;
    if (typeof value === 'number') {
      return round(result as number, 2);
    } else {
      result = parseFloat(value);
      if (isNaN(result)) {
        return '0';
      }
      return round(result, 2);
    }
    return '0';
  }
}
